import React from "react";
import HeaderMenuItem from "../HeaderMenuItem";
import button_illust_out from "../../img/buttons/illust_out.png";
import button_illust_on from "../../img/buttons/illust_on.png";
import button_costume_out from "../../img/buttons/costume_out.png";
import button_costume_on from "../../img/buttons/costume_on.png";
import button_message_out from "../../img/buttons/message_out.png";
import button_message_on from "../../img/buttons/message_on.png";
import button_quiz_out from "../../img/buttons/quiz_out.png";
import button_quiz_on from "../../img/buttons/quiz_on.png";
import "./TopPageMenu.scoped.scss";

export default function TopPageMenu() {
  return (
    <div className="buttons">
      <div className="absolute left-0 top-0">
        <HeaderMenuItem
          path="/illustrations"
          imageSource={button_illust_out}
          imageHoverSource={button_illust_on}
          description="イラスト"
        ></HeaderMenuItem>
      </div>
      <div className="absolute right-0 top-0">
        <HeaderMenuItem
          path="/costumes"
          imageSource={button_costume_out}
          imageHoverSource={button_costume_on}
          description="きせかえ"
        ></HeaderMenuItem>
      </div>
      <div className="absolute left-0 bottom-0">
        <HeaderMenuItem
          path="/messages"
          imageSource={button_message_out}
          imageHoverSource={button_message_on}
          description="メッセージ"
        ></HeaderMenuItem>
      </div>
      <div className="absolute right-0 bottom-0">
        <HeaderMenuItem
          path="/quizzes"
          imageSource={button_quiz_out}
          imageHoverSource={button_quiz_on}
          description="クイズ"
        ></HeaderMenuItem>
      </div>
    </div>
  );
}
